
const hotels = [
  {
    id: 1,
    name: 'Premier Inn London City',
    location: 'Tower Hill, Central London',
    price: '£89',
    rating: 4.5,
    features: ['Family Rooms', 'Near Halal Restaurants', 'Free WiFi'],
    image: 'https://public.readdy.ai/ai/img_res/3374161bc20bd697597f90790110e9ab.jpg',
  },
  {
    id: 2,
    name: 'Travelodge London Central',
    location: 'Aldgate, East London',
    price: '£75',
    rating: 4.3,
    features: ['Triple Rooms', 'Near Whitechapel Mosque', 'Breakfast Available'],
    image: 'https://readdy.ai/api/search-image?query=Comfortable%20budget%20hotel%20twin%20room%20with%20modern%20furnishings%2C%20clean%20and%20bright%20interior%2C%20family%20accommodation%2C%20neutral%20colors%2C%20professional%20hospitality%20photography%2C%20inviting%20atmosphere&width=600&height=400&seq=hotel-002&orientation=landscape',
  },
  {
    id: 3,
    name: 'Holiday Inn Express Stratford',
    location: 'Stratford, East London',
    price: '£95',
    rating: 4.6,
    features: ['Family Suites', 'Near Westfield', 'Complimentary Breakfast'],
    image: 'https://readdy.ai/api/search-image?query=Spacious%20hotel%20family%20suite%20with%20two%20beds%2C%20modern%20amenities%2C%20bright%20natural%20lighting%2C%20contemporary%20decor%2C%20clean%20and%20comfortable%2C%20professional%20hotel%20interior%20photography&width=600&height=400&seq=hotel-003&orientation=landscape',
  },
  {
    id: 4,
    name: 'ibis London Wembley',
    location: 'Wembley, North London',
    price: '£69',
    rating: 4.2,
    features: ['Budget Friendly', 'Near Stadium', 'Easy Transport Links'],
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20budget%20hotel%20room%20with%20comfortable%20bed%2C%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20compact%20but%20well%20designed%20space%2C%20professional%20hotel%20photography&width=600&height=400&seq=hotel-004&orientation=landscape',
  },
];

export default function BudgetHotels() {
  return (
    <section id="hotels" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#C9A961]/10 text-[#C9A961] text-sm font-medium rounded-full mb-4">
            Featured Hotels
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F2E] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Best Budget Family Hotels in London
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            The best budget family hotels in London for overseas Pakistanis visiting the UK. Carefully selected for halal dining proximity and spacious room configurations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {hotels.map((hotel) => (
            <div
              key={hotel.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={hotel.image}
                  alt={hotel.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-[#C9A961] font-bold">{hotel.price}</span>
                  <span className="text-gray-500 text-sm">/night</span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${
                          i < Math.floor(hotel.rating) ? 'text-[#C9A961]' : 'text-gray-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-gray-500 text-sm">{hotel.rating}</span>
                </div>
                <h3 className="text-xl font-bold text-[#1A1F2E] mb-2">{hotel.name}</h3>
                <p className="text-gray-500 text-sm mb-4 flex items-center gap-1">
                  <i className="ri-map-pin-line text-[#C9A961]"></i>
                  {hotel.location}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {hotel.features.map((feature, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 bg-[#FFF8E7] text-[#C9A961] text-xs rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
                <button 
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="w-full py-3 bg-[#1A1F2E] text-white rounded-lg font-medium hover:bg-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
                >
                  Enquire Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-8 py-4 bg-[#C9A961] text-white rounded-lg font-semibold hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Hotels
          </button>
        </div>
      </div>
    </section>
  );
}
